import { useEffect, useState } from 'react';
import useToast from './useToast';
import { debounce } from '../helper/debounce';
import { useSnackStack } from '../../ui/component/StackingSnackbar/StackingSnackbarProvider';

export interface ITermItem {
  [index: string]: any;
  required: boolean;
}
export interface ICheckItem extends ITermItem {
  checked: boolean;
  isExpand: boolean;
}

export type TActiveCondition = 'all' | 'essential';

export const useTermCheck = (
  termList: ITermItem[],
  activeCondition: TActiveCondition,
) => {
  // const { addToast } = useToast();
  const [checkList, setCheckList] = useState<ICheckItem[]>([]);

  const { addToast } = useSnackStack();

  const toggleCheckBox = (clickedIndex: number) => {
    // const toggle = debounce(() => {

    // }, 500);
    // toggle();
    if (checkList[clickedIndex].required) {
      addToast({ message: '필수 항목을 동의해야 해요.' });
      return;
    }

    setCheckList((prev) =>
      prev.map((item, itemIdx) => ({
        ...item,
        checked: clickedIndex === itemIdx ? !item.checked : item.checked,
      })),
    );
  };

  const toggleAllCheckBox = () => {
    setCheckList((prev) =>
      prev.map((item) => ({
        ...item,
        checked: !item.checked,
      })),
    );
  };

  const toggleExpand = (clickedIndex: number) => {
    setCheckList((prev) => {
      const result = prev.map((item, itemIndex) => ({
        ...item,
        isExpand: clickedIndex === itemIndex ? !item.isExpand : false,
      }));
      return result;
    });
  };

  const scrollInto = (e: any) => {
    const inline = checkList[checkList?.length - 1].isExpand ? 'end' : 'start';

    setTimeout(() => {
      e?.target?.scrollIntoView({ inline });
    });
  };

  const findItem = (clickedIndex: number) => {
    return checkList[clickedIndex];
  };

  const expandItem = (e: any, clickedIndex: number) => {
    toggleExpand(clickedIndex);
    scrollInto(e);
  };

  const isActive = (() => {
    switch (activeCondition) {
      case 'all':
        return checkList.every((item: any) => item.checked);
      case 'essential':
      default:
        return checkList
          .filter((item: any) => item.required)
          .every((item: any) => item.checked);
    }
  })();

  useEffect(() => {
    setCheckList(
      termList.map((item, idx) => ({
        ...item,
        key: idx,
        checked: true,
        isExpand: false,
      })),
    );
  }, [termList]);

  return {
    checkList,
    toggleCheckBox,
    toggleAllCheckBox,
    expandItem,
    findItem,
    isActive,
  };
};
